import DATAPOINT_ID_MAP_JSON from "@/data/datapoint-id-map.json";

export const DEFAULT_FILTER_COLUMNS = [
  "OLGDP001",
  "OLGDP003",
  "OLGDP004",
  "OLGDP006",
  "OLGDP007",
  "OLGDP008",
  "OLGDP101",
  "OLGDP023",
  "OLGDP024",
  "OLGDP026",
  "OLGDP027",
  "OLGDP029",
];
export const PREMIUM_DATA_MASK = "_OLG_";
export const USER_RATING_MIN = 0;
export const USER_RATING_MAX = 10;
export const RECENTLY_ADDED_THRESHOLD_DAYS = 30;
export const DATAPOINT_ID_MAP = DATAPOINT_ID_MAP_JSON;
export const DEFAULT_COUNTRY = "US";
export const DEFAULT_CURRENCY = "USD";
export const DEFAULT_LOCALE = "en-US";
export const MEASUREMENT_SYSTEMS = [
  {
    id: "imperial",
    label: "Imperial (US)",
  },
  {
    id: "metric",
    label: "Metric",
  },
];
export const DEFAULT_MEASUREMENT_SYSTEM = MEASUREMENT_SYSTEMS.find(
  ms => ms.id === "imperial",
);
export const LENGTH_UNITS = [
  {
    id: "yard",
    label: "Yard",
    system: "imperial",
  },
  {
    id: "meter",
    label: "Meter",
    system: "metric",
  },
];
export const HEIGHT_UNITS = [
  {
    id: "foot",
    label: "Foot",
    system: "imperial",
  },
  {
    id: "meter",
    label: "Meter",
    system: "metric",
  },
];
export const DISTANCE_UNITS = [
  {
    id: "mile",
    label: "Mile",
    system: "imperial",
  },
  {
    id: "kilometer",
    label: "Kilometer",
    system: "metric",
  },
];
